import styled from "styled-components"
import PropTypes from "prop-types"

const ICON_SIZE = 60

const Icon = styled.img.attrs({
  alt: "trophy",
  width: `${ICON_SIZE}px`,
  height: `${ICON_SIZE}px`,
  src: `${(props) => props.image}`
})``

Icon.propTypes = {
  image: PropTypes.string
}

export default Icon
